// Packages
import tw, { styled } from "twin.macro";

// Images
// import Amex from "../../_images/amex.png";
import Amex from "../../_images/bluebox.svg";

export const Container = styled.footer(() => [
  ``,
  tw`justify-center flex flex-col items-center box-content container mx-auto mt-14 pb-14 md:pb-20 border-t border-gray-300 relative lg:mt-20`
]);

export const Disclaimer = styled.div(({ isJP }) => [
  `a:link, a:visited, a:hover, a:focus, a:active { text-decoration: underline; color: #006fcf;}`,
  `p{margin-bottom:1rem;text-wrap:pretty;}`,
  `ul{margin-bottom:1rem;display:flex;justify-content:center;flex-wrap:wrap;gap:0;list-style:none;padding:0;}`,
  `li{text-wrap:pretty;}`,
  `li:after {content:"";font-size:1.2rem;}`,
  `li:not(:last-child)::after {color: #8e9092;content: "|";font-size: 1.2rem;font-weight: 200;margin-left: .625rem;margin-right: .625rem;}`,
  tw`text-copy text-gray-700 px-4 text-center max-w-4xl`
]);

export const Logo = styled.div(() => [
  `background-image: url("${Amex}"); width:48px; height:48px; background-size: 48px 48px;`,
  tw`bg-center bg-contain bg-no-repeat mx-auto mt-4 block md:mt-0 py-12`
]);
